module.exports = __webpack_public_path__ + "static/media/jchan.faa69772.jpg";